export default __webpack_public_path__ + "static/Peachy_sky-1831c21462c9342dfa7986aa060fbb2e.png";